import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleInativarModelo } from "@/domain/use-cases/modelos";
import {
  getApiErrorHttpStatus,
  getApiErrorMessage,
} from "@/utils/normalize-api-error/normalize-api-error";
import { notifyAlert, notifyError, notifySuccess } from "@/utils/notify-messages";

export function useInativarModelo() {
  const queryClient = useQueryClient();
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation({
    mutationFn: async (modelo_id: number) => {
      return await handleInativarModelo(token!, modelo_id);
    },
    onSuccess: async (response: any) => {
      notifySuccess(response?.message ?? "Modelo inativado com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["modelos"] });
      await queryClient.invalidateQueries({ queryKey: ["modelos-por-cliente"] });
      await queryClient.invalidateQueries({ queryKey: ["modelos-unico"] });
    },
    onError: (error) => {
      // Erro esperado (regra de negócio / integridade) → alerta
      if (getApiErrorHttpStatus(error) === 422) {
        notifyAlert(getApiErrorMessage(error));
        return;
      }

      notifyError(getApiErrorMessage(error));
    },
  });

  return {
    inativarModelo: mutation.mutate,
    inativarModeloAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
}
